






















































































































import FileUploadMulti from "@/components/files/FileUploadMulti.vue";
import FileInput from "@/components/utility/FileInput.vue";
import { beforeCurrentDateRule, dateRule } from "@/lib/rules/dateRule";
import { isNumberRule } from "@/lib/rules/isNumberRule";
import { maxSizeRule } from "@/lib/rules/maxSizeRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { SignCreateDocumentDtoGen } from "@/services/sign/v1/data-contracts";
import { ISignDocument } from "@/models/sign-document.entity";
import { Component, Prop } from "vue-property-decorator";
import SelectTags from "@/components/tag/v2/SelectTags.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import { mixins } from "vue-class-component";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ITag } from "@/models/tag.entity";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import FileInputMixin from "@/components/utility/FileInputMixin.vue";
import CustomFieldBoolean from "@/components/report/CustomFieldBoolean.vue";

class CreateDocumentDtoGen implements Omit<SignCreateDocumentDtoGen, "file" | "tags"> {
  name = "";
  file?: File;
  title = "";
  folder? = "/";
  description?: string;
  tagIds: string[] = [];
  tags: ITag[] = [];
  isTemplate = false;
  isShared = false;

  /** Getter to convert isInternal to isShared for backend API */
  get isInternal(): boolean {
    return !this.isShared;
  }

  /** Setter to convert isShared to isInternal for form logic */
  set isInternal(value: boolean) {
    this.isShared = !value;
  }

  constructor(document?: ISignDocument) {
    if (document) {
      this.file = document.file;
      this.name = document.name;
      this.title = document.title;
      this.folder = document.folder;
      this.description = document.description;
      this.tags = document.tags || [];
      this.tagIds = (document.tags || []).map(tag => tag.id);
      this.isTemplate = document.isTemplate;
      this.isShared = document?.isShared || false;
    }
  }
}

@Component({
  components: { FileUploadMulti, FileInput, SelectTags, Tooltip, CustomFieldBoolean }
})
export default class SignDocumentForm extends mixins(PermissionMixin, FileInputMixin) {
  @Prop({ default: false })
  isLoading!: boolean;

  @Prop({})
  document!: ISignDocument;

  @Prop({})
  prefillDocument!: CreateDocumentDtoGen;

  @Prop({ default: false })
  hideTemplateOption?: boolean;

  @Prop({ default: false })
  hideButton?: boolean;

  @Prop({ default: "/" })
  folder?: string;

  @Prop({ required: true })
  partnerId!: string;

  @Prop({ default: false })
  showFolder!: boolean;

  @Prop({ default: false })
  showIsTemplate!: boolean;
  @Prop({ default: false })
  isUpdate!: boolean;

  PartnerTypeEnum = PartnerTypeEnum;

  isValid = false;

  readonly maxFileSizeInMb = 5;

  get partner() {
    return PartnerModule.partner;
  }

  get valid() {
    this.$emit("updateValid", this.isValid);
    return this.isValid;
  }

  set valid(valid: boolean) {
    this.isValid = valid;
    this.$emit("updateValid", this.isValid);
  }

  get disabled() {
    return this.isLoading || typeof this.document !== "undefined";
  }

  get maxSizeRule() {
    return [maxSizeRule(this.maxFileSizeInMb * 1000 * 1024), requiredRule()];
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get numberRule() {
    return [isNumberRule(), requiredRule()];
  }

  get dateRule() {
    return [dateRule(), beforeCurrentDateRule()];
  }

  startDrag() {
    this.isDrag = true;
  }

  endDrag() {
    this.isDrag = false;
  }

  createDocumentDto: CreateDocumentDtoGen = (() => {
    const doc = new CreateDocumentDtoGen(this.document);

    if (!this.document) {
      doc.folder = this.folder;
    }

    return doc;
  })();

  save() {
    this.$emit("save", this.createDocumentDto);
  }

  resetForm() {
    this.createDocumentDto = new CreateDocumentDtoGen(this.document);
  }

  onChange(file: File) {
    this.createDocumentDto.name = file.name;
    this.createDocumentDto.title = file.name;
  }

  async setFile(file: File): Promise<void> {
    this.createDocumentDto.file = file;
    this.onChange(file);
  }

  setTags(tags: ITag[]) {
    this.createDocumentDto.tags = [...tags];
    this.createDocumentDto.tagIds = tags.map(tag => tag.id);
  }

  removeWhiteSpace() {
    if (this.createDocumentDto.folder) {
      this.createDocumentDto.folder = this.createDocumentDto.folder.replace(/\s/g, "");
    }
  }
}
